import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import MainContainer from "pages/_components/MainContainer";
import * as i18n from "util/i18n";
import Button from "pages/_components/Button";
import Action from "pages/_components/Action";
import { TransactionCard, TransactionHeader } from "pages/_components/TransactionCard";
import { ResponsiveHeader, DesktopButtons, MobileButtons } from "pages/_components/header";
import useReactPrint from "pages/_components/Print/useReactToPrint";
import { actions as creditBillActions } from "reducers/creditBills";
import Notification from "pages/_components/Notification";
import { bool } from "prop-types";
import { useTransaction } from "hooks/useTransactions";
import Image from "pages/_components/Image";
import CreditBillsSummaryBody from "./components/Summary";

const CreditBillsTransactionPage = ({ isDesktop }) => {
    const formatData = (data, idTransaction) => ({ ...data, idTransaction });

    const {
        isLoading,
        transaction,
        dispatch,
        handleSignTransaction,
        showSignButton,
        push,
        id,
        status,
    } = useTransaction(
        "/creditBills/inform/sumary",
        creditBillActions.setActionData,
        creditBillActions.cleanServiceTicket,
        formatData,
    );

    const { isFinished, isFlowComplete, isBackoffice } = status;
    const { componentRef, handlePrint, handlePrintMobile, mobileRef, handleShareMobile } = useReactPrint(
        "credit.bills.modify.cbu.title",
        id,
        "credit.bills.trasaction",
    );
    const [showMoreData, setShowMoreData] = useState(!isDesktop);
    const backLinkTo = isFlowComplete ? "/creditBills" : "";

    const handleDownloadMobile = async () => {
        await setShowMoreData(true);
        return handlePrintMobile();
    };
    const handleDownloadDesktop = async () => {
        await setShowMoreData(true);
        return handlePrint();
    };

    return (
        <>
            <Notification scopeToShow="credit.bills.trasaction" />
            {!isBackoffice && (
                <ResponsiveHeader ticket metaTitle="credit.bills.modify.cbu.title" backLinkTo={backLinkTo}>
                    {isFinished && (
                        <>
                            <DesktopButtons>
                                <Button
                                    className="btn btn-outline"
                                    image="images/download.svg"
                                    label="global.download"
                                    onClick={handleDownloadDesktop}
                                    block={false}
                                />
                            </DesktopButtons>
                            <MobileButtons>
                                <Action labelKey="global.download" handleClick={handleDownloadMobile} />
                                <Action labelKey="global.share" handleClick={handleShareMobile} />
                            </MobileButtons>
                        </>
                    )}
                </ResponsiveHeader>
            )}
            <MainContainer showLoader={isLoading}>
                <div className="container" ref={componentRef}>
                    <div ref={mobileRef}>
                        <TransactionCard transaction={transaction}>
                            <TransactionHeader title="credit.bills.modify.cbu.title" />
                            <div className="ticket">
                                <div className="ticket__wrapper">
                                    <div className="ticket__header" />
                                    <CreditBillsSummaryBody
                                        isRecipt
                                        isDesktop={isDesktop}
                                        setShowMoreData={setShowMoreData}
                                        showMoreData={showMoreData}
                                    />
                                    {isFinished && (
                                        <div className="text-center">
                                            <div className="ticket__divider inside-ticket__body">
                                                <div className="ticket__notch ticket__notch--left"> </div>
                                                <div className="ticket__notch ticket__notch--right"> </div>
                                            </div>
                                            <Image src="images/figma/illustrations/rapipago.svg" />
                                        </div>
                                    )}
                                    <div className="ticket__footer" data-copytext={i18n.get("global.ticketCopyText")} />
                                </div>
                            </div>
                        </TransactionCard>
                    </div>
                    {!isBackoffice && (
                        <Row className="form-actions no-print">
                            {!isFinished && (
                                <Col xs={12} md={4} mdOffset={showSignButton ? 2 : 4}>
                                    <Button
                                        onClick={() => dispatch(push("/desktop"))}
                                        label="forms.transaction.ticket.actions.backToHome"
                                        className={`btn${showSignButton ? " btn-outline" : " btn-primary"}`}
                                    />
                                </Col>
                            )}
                            {showSignButton && (
                                <Col xs={12} md={4} mdOffset={6}>
                                    <Button
                                        onClick={handleSignTransaction}
                                        label="forms.signTransaction.link"
                                        className="btn btn-primary"
                                    />
                                </Col>
                            )}
                        </Row>
                    )}
                </div>
            </MainContainer>
        </>
    );
};

CreditBillsTransactionPage.propTypes = {
    isDesktop: bool.isRequired,
};

export default CreditBillsTransactionPage;
